import Vue from 'Vue'
import Vuex from 'Vuex'

Vue.use(Vuex);

let setCookie = function (cname, cvalue, exdays) {
	var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toUTCString();
  // document.cookie = cname + "=" + cvalue + "; " + expires;
	document.cookie = cname + "="+ escape (cvalue) + ";" +expires+";path=/;"; 
}

let getCookie = function(cname) {
	var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return "";
}

let delCookie = function(name) {
	setCookie(name, "", -1);
}

const store = new Vuex.Store({
  // 全局变量
  state: {
    user: undefined,
    subscribers: []
  },
  getters: {
    user(state) {
      return state.user
    },
    token() {
      return getCookie('user_token')
    }
  },
  // 修改全局变量必须通过mutations中的方法
  // mutations只能采用同步方法
  mutations: {
    login(state, payload) {
      state.user = payload
    },
    logout(state) {
      state.user = undefined
    },
    notify(state) {
      state.subscribers.forEach(function(callback){
        // console.log(callback);
        callback(state.user);
      })
    }
  },
  // 异步方法用actions
  // actions不能直接修改全局变量，需要调用commit方法来触发mutation中的方法
  actions: {
    login(context, payload) {
      if (payload.token) {
        setCookie('user_token', payload.token, 30)
      }
      context.commit('login', payload)
      context.commit('notify')
    },
    logout(context) {
      delCookie('user_token')

      context.commit('logout')
      context.commit('notify')
    },
    notify(context, callback) {
      context.state.subscribers.push(callback);
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store.js